import PropTypes from 'prop-types';
import React from 'react';

import { Row, DefaultSheet, SheetBody } from 'twyne-new.ui';

import AuditResultBodyItem from './AuditResultBodyItem';

const AuditResultDetails = ({ request, toggle }) => {
  const isOpen = request ? true : false;
  if (!isOpen) {
    return null;
  }

  const data = Object.entries(request);

  return <>
    <DefaultSheet title='Request Details' wrapperProps={{ open: isOpen, onOpenChange: toggle }} >
      <SheetBody>
        <Row>
          {data.map((item, index) => <>
            <AuditResultBodyItem size='6' key={index} label={item[0]} value={item[1].length ? item[1] : '--'} />
          </>)}
        </Row>
      </SheetBody>
    </DefaultSheet>
  </>
}

AuditResultDetails.propTypes = {
  request: PropTypes.object,
  toggle: PropTypes.func,
};

export default AuditResultDetails;
